import React, { useEffect,useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import { Outlet, useNavigate } from "react-router-dom";
import DashboardPageHeader from "../../components/Header/DashboardPageHeader";
import serverDown from '../../assets/icons/connection-lost.svg';
import CookieHandler from '../../pages/LandingPage/Authentication/CookieHandler';
import GetRequest from "../../service/GetRequest";

const MainLayout = ({ activePath }) => {
  const navigate = useNavigate();
  const [isServerDown, setIsServerDown] = useState(false);
  const [isSideBarActive, setIsSideBarActive] = useState(true);


  const toggleSidebar = () => {
    setIsSideBarActive(!isSideBarActive);
  };


  useEffect(() => {
    const storedIsLoggedIn = CookieHandler.getCookie("isLoggedIn") === "true";

    if (!storedIsLoggedIn) {
      navigate("/login");
    }

    const interval = setInterval(() => {
     checkServerStatus();
    }, 10000); // Check server status every 5 seconds

    return () => clearInterval(interval); 
  }, [navigate]);

  const checkServerStatus = () => {
    GetRequest("auth/ping", false)
              .then(response => {
                  if (!response || response === undefined) {
                    setIsServerDown(true);
                  } else {
                    setIsServerDown(false);
                  }
                });
  };
  

  return (
    <div className="main-layout">
      {/* Sidebar component */}
      <Sidebar activePath={activePath} isSideBarActive={isSideBarActive} toggleSidebar={toggleSidebar} />
      <div className="main-component" >
      <DashboardPageHeader activePath={activePath} toggleSidebar={toggleSidebar} />
      {/* Outlet for rendering nested routes */}
        {isServerDown ? (
          <div className="outlet-container">
          <div className="background-white">
            <div className="background-white-sub-container">
              <br/><br/><br/><br/><br/><br/><br/><br/><br/>
              <div className='centralised-text'>
                    <img
                        loading="lazy"
                        alt="icon"
                        src={serverDown} // Use src instead of srcSet if you're not using multiple image sources
                        style={{ height: '150px', width: '150px', alignItems:'center', opacity:'0.4'}} // Set height and width to adjust the size of the image
                        /></div>
            <p style={{ textAlign: 'center',opacity:'0.4' }}>Connection to server failed. Please try again later.</p>
          </div></div></div>
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
};

export default MainLayout;
